import { render, staticRenderFns } from "./add-audio-group-modal.vue?vue&type=template&id=044dc77d&scoped=true&"
import script from "./add-audio-group-modal.vue?vue&type=script&lang=ts&"
export * from "./add-audio-group-modal.vue?vue&type=script&lang=ts&"
import style0 from "./add-audio-group-modal.vue?vue&type=style&index=0&id=044dc77d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044dc77d",
  null
  
)

export default component.exports